import React, { useState } from "react";
import './DemographicsBox.css'
import TitleText from "./TitleText";
import SelectOption from './SelectOption';
import {
    EmploymentStatus,
    EducationLevel,
    ActivityYearsName,
    ActivityYearsAmount,
    ActivityMonthsName,
    ActivityMonthsAmount,
    MainRole,
    TeamSize,
    RequestDemographics,
    TARGET_DEMOGRAPHICS,
    urlFor,
    postJson,
    FrequencyAsk,
    InfoSource
} from "../utils/comms";
import TextInput from "./TextInput";
import Button from "./Button";
import { useNavigate } from "react-router-dom";
import { getAccessToken } from "../utils/cookies";

function DemographicsBox() {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [requestDemographics, setRequestDemographics] = useState(new RequestDemographics());
    const updateRequestDemographics = (updates) => {
        setRequestDemographics((requestDemographics) => {
            const newRequestDemographics = { ...requestDemographics, ...updates };
            return newRequestDemographics;
        });
    };

    const navigate = useNavigate();

    const handleSubmit = async () => {
        if (isSubmitting)
            return;
        setIsSubmitting(true);

        try {
            const tagetUrl = urlFor(TARGET_DEMOGRAPHICS);
            requestDemographics.auth_token = getAccessToken();
            await postJson(tagetUrl, requestDemographics);
            navigate("/home")
        } catch (err) {
            alert(err.response.error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="demographics-box">
            <TitleText
                text={"Demographics"}
            />

            <TextInput
                labelText={"What is your gender? (Optional)"}
                onChange={(gender_text) => {
                    updateRequestDemographics({gender: gender_text});
                }}
            />

            <TextInput
                labelText={"What is your age? *"}
                onChange={(age_text) => {
                    updateRequestDemographics({age: age_text});
                }}
            />

            <SelectOption
                promptText="What is your highest achieved level of education? *"
                options={Object.values(EducationLevel)}
                onOptionSelect={(option_text) => {
                    updateRequestDemographics({education_level: option_text});
                }}
            />

            <SelectOption
                promptText="What's your current employment status? *"
                options={Object.values(EmploymentStatus)}
                onOptionSelect={(option_text) => {
                    updateRequestDemographics({employment_status: option_text});
                }}
            />

            <p>Please specify for how many years you have performed the following activities</p>
            {Object.values(ActivityYearsName).map((name, index) => (
                <SelectOption
                    key={index}
                    promptText={name + "*"}
                    options={Object.values(ActivityYearsAmount)}
                    onOptionSelect={(selectedOption) => {
                        let activityYears = requestDemographics.activity_years;
                        if (activityYears == null) {
                            activityYears = new Object();
                        }
                        Reflect.set(activityYears, name, selectedOption);
                        updateRequestDemographics({activity_years: activityYears});
                    }}
                />
            ))}

            <p>Please specify how often you have performed the following activities in the last three months</p>
            {Object.values(ActivityMonthsName).map((name, index) => (
                <SelectOption
                    key={index}
                    promptText={name + "*"}
                    options={Object.values(ActivityMonthsAmount)}
                    onOptionSelect={(selectedOption) => {
                        let activityMonths = requestDemographics.activity_months;
                        if (activityMonths == null) {
                            activityMonths = new Object();
                        }
                        Reflect.set(activityMonths, name, selectedOption);
                        updateRequestDemographics({activity_months: activityMonths});
                    }}
                />
            ))}

            <SelectOption
                promptText="How often do you ask questions about code related topics? (Peers, Stack Overflow, AI-Tools, etc) *"
                options={Object.values(FrequencyAsk)}
                onOptionSelect={(option) => {
                    updateRequestDemographics({frequecy_ask: option});
                }}
            />

            <SelectOption
                promptText="What is your main source of information for coding related questions? *"
                options={Object.values(InfoSource)}
                onOptionSelect={(option) => {
                    updateRequestDemographics({info_source: option});
                }}
            />

            <SelectOption
                promptText="What is your main role? *"
                options={Object.values(MainRole)}
                onOptionSelect={(option) => {
                    updateRequestDemographics({main_role: option});
                }}
            />

            <SelectOption
                promptText="How big is your immediate team? *"
                options={Object.values(TeamSize)}
                onOptionSelect={(option) => {
                    updateRequestDemographics({team_size: option});
                }}
            />

            { !isSubmitting &&
                <Button
                    text={"Continue"}
                    onClick={handleSubmit}
                />
            }

        </div>
    );
}

export default DemographicsBox;

